import { render, staticRenderFns } from "./GroupInvitation.vue?vue&type=template&id=59fbca01"
import script from "./GroupInvitation.vue?vue&type=script&lang=js"
export * from "./GroupInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports